/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_CASH_RECEIPT_SUMMARY,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ADJUSTMENT_REASON_CODE,
  isLoading: value,
});
//selected report
export const dispatchReportType = (data) => ({
  type: ActionTypes.SET_SELECTED_REPORT_DRUG,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_CASH_RECEIPT_SUMMARY,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};
export const handleErrorMessagesCRS = (data) => ({
  type: ActionTypes.HANDLE_ERROR_MESSAGE_CRS,
  errorMessagesInRedux: data,
});
// To get the defaut selection on the req screen when reopening the req screen
export const refreshCashReceiptSummary = (data) => ({
  type: ActionTypes.REFRESH_CASH_RECEIPT_SUMMARY,
  payload: data,
});
export const refreshCashReceiptSummaryDisplay = () => ({
  type: ActionTypes.REFRESH_CASH_RECEIPT_SUMMARY_DISPLAY,
  payload: {},
});
// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setCashReceiptSummaryGrid = (data) => ({
  type: ActionTypes.GET_RESULT_GRID_CASH_RECEIPT_SUMMARY,
  searchResult: data,
});

// Result Grid
export const getResultGridCashSummary = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_CASH_RECEIPT_SUMMARY}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.cashReceiptSummaryReportVO.length === 0) {
        dispatch(
          handleErrorMessagesCRS([
            {
              field: 'resultNotFound',
              errorType: 'resultNotFound',
              message: NO_DATA,
            },
          ])
        );
      } else {
        return dispatch(
          setCashReceiptSummaryGrid(response.data?.cashReceiptSummaryReportVO)
        );
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(setCashReceiptSummaryGrid([]));
      dispatch(
        handleErrorMessagesCRS([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: NO_DATA,
          },
        ])
      );
    });
};

// Result Grid
export const getResultGridNonMatCashSummary = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_CASH_RECEIPT_NON_MAT_SUMMARY}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.cashReceiptSummaryReportVO.length === 0) {
        dispatch(
          handleErrorMessagesCRS([
            {
              field: 'resultNotFound',
              errorType: 'resultNotFound',
              message: NO_DATA,
            },
          ])
        );
      } else {
        return dispatch(
          setCashReceiptSummaryGrid(response.data?.cashReceiptSummaryReportVO)
        );
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(setCashReceiptSummaryGrid([]));
      dispatch(
        handleErrorMessagesCRS([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: NO_DATA,
          },
        ])
      );
    });
};
